export default {
  booking: {
    label: 'Booking',
    allowed_statuses: ['initial', 'created', 'reviewed']
  },
  extras: {
    label: 'Extras',
    allowed_statuses: ['created', 'reviewed']
  },
  'your-details': {
    label: 'Your Details',
    allowed_statuses: ['reviewed'],
    related_routes: ['password', 'register', 'your-details']
  },
  payment: {
    label: 'Payment',
    allowed_statuses: ['reviewed']
  },
  summary: {
    label: 'Summary',
    allowed_statuses: ['paid']
  }
}
